export default function NodepositBonuses() {
  const nodepositOffers = [
    {
      casino: "SOL",
      offer: "50 фриспинов",
      game: "Book of Dead",
      wager: "x35",
      maxWin: "5 000 ₽",
      url: "https://sol-blsm10.com/c26114c36"
    },
    {
      casino: "FRESH",
      offer: "1000 ₽",
      game: "Любые слоты",
      wager: "x40",
      maxWin: "3 000 ₽",
      url: "https://fresh-blrs10.com/cf443d7fa"
    },
    {
      casino: "LEX",
      offer: "30 фриспинов",
      game: "Starburst",
      wager: "x30",
      maxWin: "4 000 ₽",
      url: "https://lexyway1.com/c737609d2"
    },
    {
      casino: "GIZBO",
      offer: "25 фриспинов",
      game: "Gonzo's Quest",
      wager: "x35",
      maxWin: "5 000 ₽",
      url: "https://gizbo-way-seven.com/ce6052c2f"
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white animate-on-scroll opacity-0">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Лучшие казино онлайн с бездепозитными бонусами
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Фриспины за регистрацию — играйте бесплатно и выигрывайте реальные деньги без пополнения счета
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {nodepositOffers.map((offer, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:scale-105"
            >
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{offer.casino}</h3>
                  <div className="text-3xl font-bold text-orange-600">{offer.offer}</div>
                </div>
                <div className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                  Без депозита
                </div>
              </div>

              <div className="space-y-3 mb-6">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">Игра:</span>
                  <span className="font-semibold text-gray-900">{offer.game}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">Вейджер:</span>
                  <span className="font-semibold text-gray-900">{offer.wager}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">Макс. вывод:</span>
                  <span className="font-semibold text-orange-600">{offer.maxWin}</span>
                </div>
              </div>

              <a
                href={offer.url}
                target="_blank"
                rel="nofollow sponsored noopener noreferrer"
                className="block w-full py-4 bg-gradient-to-r from-green-500 to-green-600 text-white text-center font-bold rounded-xl hover:from-green-600 hover:to-green-700 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
              >
                Получить бездепозитный бонус
                <i className="ri-gift-line ml-2"></i>
              </a>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-8 border border-green-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            Как получить бездепозитный бонус в казино онлайн?
          </h3>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Регистрация</h4>
              <p className="text-sm text-gray-600">Создайте аккаунт в выбранном казино онлайн</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Верификация</h4>
              <p className="text-sm text-gray-600">Подтвердите email или номер телефона</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Активация</h4>
              <p className="text-sm text-gray-600">Бонус зачислится автоматически</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">4</span>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Игра</h4>
              <p className="text-sm text-gray-600">Используйте бонус и выигрывайте</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}